import React, { useState, useRef } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { APICALL } from "../api/api";
import { Eye, EyeOff } from "lucide-react";

const Otpverification = () => {
  const location = useLocation();
  const email = location?.state;
  const navigate = useNavigate();
  const [resetForm, setResetForm] = useState(false);

  const OTP_LENGTH = 6;
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(""));
  const inputsRef = useRef([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (element, index) => {
    const value = element.value.replace(/\D/g, "");
    if (!value) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (index < OTP_LENGTH - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const code = otp.join("");
    const params = { email: email, otp: code };
    setErr(null);
    try {
      setLoading(true);
      const res = await APICALL("/user/verifyOtp", "post", params);
      if (res?.status === 200) {
        setResetForm(true);
      } else {
        setErr(res?.message || "Login failed!");
      }
    } catch (err) {
      setErr(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setErr(null);

    if (password.length < 6) {
      setErr("Password must be at least 6 characters long.");
      return;
    }

    if (password !== confirmPassword) {
      setErr("Passwords do not match.");
      return;
    }

    const params = { email, password };
    try {
      setLoading(true);
      const res = await APICALL("/user/resetPasswordWithOtp", "post", params);
      if (res?.status === 200) {
        navigate("/");
      } else {
        setErr(res?.message || "Login failed!");
      }
    } catch (err) {
      setErr(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="login_page">
        <Container>
          <Row className="justify-content-center">
            <Col md={6}>
              {!resetForm ? (
                <div className="login-card">
                  <div className="text-center mb-4">
                    <div className="ai-icon mb-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="40"
                        height="40"
                        viewBox="0 0 512 512"
                        style={{ enableBackground: "new 0 0 512 512" }}
                        xmlSpace="preserve"
                      >
                        <g>
                          <path
                            d="M458.474 112H265V62.41A31.381 31.381 0 0 0 233.588 31H62.408A31.38 31.38 0 0 0 31 62.41v387.18A31.438 31.438 0 0 0 62.408 481h171.18A31.439 31.439 0 0 0 265 449.59V292h193.477A22.523 22.523 0 0 0 481 269.477V134.526A22.526 22.526 0 0 0 458.474 112ZM125.5 50.08h45a11.25 11.25 0 0 1 0 22.5h-45a11.25 11.25 0 0 1 0-22.5Zm44.996 411.765h-45a11.25 11.25 0 1 1 0-22.5h45a11.25 11.25 0 0 1 0 22.5Zm74.702-41.595h-194.4V91.75h194.4V112H125.315A22.315 22.315 0 0 0 103 134.315v135.35A22.336 22.336 0 0 0 125.336 292H166v36.149a11.122 11.122 0 0 0 18.987 7.864L229 292h16.198Zm-24.39-210.06a11.309 11.309 0 0 1 4.14 15.39 11.198 11.198 0 0 1-15.39 4.14l-14.308-8.28V238a11.25 11.25 0 0 1-22.5 0v-16.56l-14.313 8.28a11.198 11.198 0 0 1-15.39-4.14 11.316 11.316 0 0 1 4.14-15.39L161.5 202l-14.313-8.28a11.269 11.269 0 0 1 11.25-19.53l14.313 8.28V166a11.25 11.25 0 0 1 22.5 0v16.47l14.309-8.28a11.269 11.269 0 0 1 11.25 19.53L206.5 202Zm108 0a11.309 11.309 0 0 1 4.14 15.39 11.198 11.198 0 0 1-15.39 4.14l-14.308-8.28V238a11.25 11.25 0 0 1-22.5 0v-16.56l-14.313 8.28a11.198 11.198 0 0 1-15.39-4.14 11.316 11.316 0 0 1 4.14-15.39L269.5 202l-14.313-8.28a11.269 11.269 0 0 1 11.25-19.53l14.313 8.28V166a11.25 11.25 0 0 1 22.5 0v16.47l14.309-8.28a11.269 11.269 0 0 1 11.25 19.53L314.5 202Zm108 0a11.309 11.309 0 0 1 4.14 15.39 11.198 11.198 0 0 1-15.39 4.14l-14.308-8.28V238a11.25 11.25 0 0 1-22.5 0v-16.56l-14.313 8.28a11.198 11.198 0 0 1-15.39-4.14 11.316 11.316 0 0 1 4.14-15.39L377.5 202l-14.313-8.28a11.269 11.269 0 0 1 11.25-19.53l14.313 8.28V166a11.25 11.25 0 0 1 22.5 0v16.47l14.309-8.28a11.269 11.269 0 0 1 11.25 19.53L422.5 202Z"
                            fill="#ffffff"
                            opacity="1"
                          />
                        </g>
                      </svg>
                    </div>
                    <h1 className="login-title">Otp Verification</h1>
                    <p className="text-white">
                      Enter the OTP sent to your email ({email}) to proceed.
                    </p>
                  </div>

                  <Form onSubmit={handleSubmit}>
                    <Form.Label className="mb-3">
                      Enter the 6-digit code sent to your email
                    </Form.Label>
                    <div className="otp_box d-flex justify-content-between mb-4">
                      {otp.map((digit, index) => (
                        <Form.Control
                          key={index}
                          type="text"
                          inputMode="numeric"
                          maxLength="1"
                          className="text-center mx-1"
                          value={digit}
                          onChange={(e) => handleChange(e.target, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          ref={(el) => (inputsRef.current[index] = el)}
                          style={{
                            width: "40px",
                            height: "50px",
                            fontSize: "24px",
                          }}
                          required
                        />
                      ))}
                    </div>
                    {err && (
                      <p className="text-danger">
                        <strong> {err}</strong>
                      </p>
                    )}
                    <Button
                      type="submit"
                      className="btn-gradient w-100 mb-3"
                      size="lg"
                    >
                      {loading ? "Loading..." : " Verify OTP"}
                    </Button>
                  </Form>
                </div>
              ) : (
                <div className="login-card">
                  <div className="text-center mb-4">
                    <div className="ai-icon mb-3">
                      {/* Your SVG icon here */}
                    </div>
                    <h1 className="login-title">Reset Password</h1>
                  </div>

                  <Form onSubmit={handleReset}>
                    {/* Password */}
                    <div className="position-relative mb-3">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter new password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        minLength={6}
                        className="form-control-dark pe-5"
                      />
                      <Button
                        variant="link"
                        className="position-absolute top-50 end-0 translate-middle-y pe-3 text-light border-0"
                        onClick={() => setShowPassword(!showPassword)}
                        type="button"
                      >
                        {showPassword ? (
                          <EyeOff size={16} />
                        ) : (
                          <Eye size={16} />
                        )}
                      </Button>
                    </div>

                    {/* Confirm Password */}
                    <div className="position-relative mb-3">
                      <Form.Control
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        minLength={6}
                        className="form-control-dark pe-5"
                      />
                      <Button
                        variant="link"
                        className="position-absolute top-50 end-0 translate-middle-y pe-3 text-light border-0"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        type="button"
                      >
                        {showConfirmPassword ? (
                          <EyeOff size={16} />
                        ) : (
                          <Eye size={16} />
                        )}
                      </Button>
                    </div>

                    {/* Error Message */}
                    {err && (
                      <p className="text-danger">
                        <strong>{err}</strong>
                      </p>
                    )}

                    {/* Submit */}
                    <Button
                      type="submit"
                      className="btn-gradient w-100 mb-3"
                      size="lg"
                    >
                      {loading ? "Loading..." : "Change Password"}
                    </Button>
                  </Form>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Otpverification;
